export const referralPriorityOptions = [
  { value: 1, label: 'No Priority For This Keyword (Default)' },
  { value: 2, label: 'Show The Customer\'s Resources FIRST' }
]

export const qrCodePlacementOptions = [
  { name: 'Flyers', value: 'Flyers' },
  { name: 'Store', value: 'Store' },
  { name: 'Business Cards', value: 'Business Cards' }
]



// WEBPACK FOOTER //
// ./src/components/keyword-management/constants.js